import { DelayWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Delay')
export class DelayConnectorProvider extends ConnectorProvider<DelayWorkflowNode> {}
